<template>
	<button
		:class="[$style['dropdown-menu-link'], {
			[$style['dropdown-menu-link--danger']]: item.danger
		}]"
		@click="handleClick"
	>
		<FontAwesomeIcon
			v-if="item.leadingIcon"
			:icon="item.leadingIcon.split(' ')"
			:class="$style['dropdown-menu-link__leading-icon']"
		/>
		{{ item.title }}
		<FontAwesomeIcon
			v-if="item.icon && !item.isLoading"
			:icon="item.icon.split(' ')"
			:class="$style['dropdown-menu-link__icon']"
		/>
		<FontAwesomeIcon
			v-if="item.isLoading"
			:icon="['far', 'circle-notch']"
			:class="[$style['dropdown-menu-link__icon'], $style['dropdown-menu-link__icon--loader']]"
		/>
	</button>
</template>
<script>
export default {
	name: 'DropdownMenuLink',
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	methods: {
		handleClick (event) {
			this.$emit('click', event)
		}
	}
}
</script>
<style lang="scss" module>


	.dropdown-menu-link {
		display: flex;
		align-items: center;
		line-height: 1;
		background-color: getColor(surface-elevated);
		border: 0;
		font-size: 14px;
		padding: $gutter $gutter * 2;
		width: 100%;
		outline: 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		text-align: left;
		height: 48px;
		font-family: inherit;
		color: getColor(text);
		transition: background-color 0.12s ease, color 0.12s ease;

		&:hover {
			cursor: pointer;
			background-color: getColor(hover-overlay-solid);

			@include dark-mode {
				background-color: getColor(hover-overlay-strong);
			}
		}

		&__icon {
			margin-left: auto;
			font-size: 14px;

			&--loader {
				animation: rotator 1.4s linear infinite;
			}
		}

		&__leading-icon {
			font-size: 14px;
			margin-right: $gutter * 1.5;
		}

		&--danger {
			color: getColor(danger);
		}
	}

	@keyframes rotator {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}
</style>
